export default __webpack_public_path__ + "static/media/capistrano.563f923d.svg";